import { Controller } from "@hotwired/stimulus"

// Attached to the CP2020 childhood-environment <select>. Its sole job is to
// announce a selection change: on `change` it dispatches a window-level
// `cp2020:environment-changed` event carrying the chosen slug. The skills editor
// (a separate, sibling controller) listens for that event to restamp upbringing
// bonuses — so neither controller reaches into the other's DOM; the select owns
// its change, skills owns its reaction.
//
// The action is bound to THIS controller's own element (change->#broadcast), so
// it catches slim-select's native change on the underlying <select> without the
// stale-binding problem a cross-element action would hit.
export default class extends Controller {
  broadcast() {
    this.dispatch("environment-changed", {
      prefix: "cp2020",
      target: window,
      detail: { slug: this.element.value },
    })
  }
}
